import { render, staticRenderFns } from "./assistant-form.vue?vue&type=template&id=39c57041&"
import script from "./assistant-form.vue?vue&type=script&lang=js&"
export * from "./assistant-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports